// extracted by mini-css-extract-plugin
export default {"root":"CollectionViewMobile_root__Fvxwi","top":"CollectionViewMobile_top__GiM74","content":"CollectionViewMobile_content__s2wNM","bottom":"CollectionViewMobile_bottom__NosnY"};